/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OARewardsDistributor } from "../OARewardsDistributor";

export class OARewardsDistributor__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(_OA: string, overrides?: Overrides): Promise<OARewardsDistributor> {
    return super.deploy(_OA, overrides || {}) as Promise<OARewardsDistributor>;
  }
  getDeployTransaction(_OA: string, overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(_OA, overrides || {});
  }
  attach(address: string): OARewardsDistributor {
    return super.attach(address) as OARewardsDistributor;
  }
  connect(signer: Signer): OARewardsDistributor__factory {
    return super.connect(signer) as OARewardsDistributor__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OARewardsDistributor {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as OARewardsDistributor;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_OA",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "adder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "rewardToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountAdded",
        type: "uint256",
      },
    ],
    name: "RewardAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "rewardToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountClaimed",
        type: "uint256",
      },
    ],
    name: "RewardClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OA",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "claimReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "getRewardsBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "getRewardsBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rewardsClaimedByNFT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalRewardsPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "erc20",
        type: "address",
      },
    ],
    name: "updateERC20Rewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateEvmosRewards",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_OA",
        type: "address",
      },
    ],
    name: "updateOAContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";
